<template lang="pug">
div
  el-divider 关联更新
  el-form-item(label="最大高度")
    el-input(v-model="gridMaxHeight", maxlength="10")
  el-form-item(label="固定列数")
    el-input-number(v-model="fixedNum")
  el-form-item(label="关联子表", :rules="nameRequiredRule")
    el-select(v-model="sublist", allow-create, filterable)
      el-option(v-for="(sf, sfIdx) in subformList", :key="sfIdx", :label="sf.label", :value="sf.name")
</template>

<script>
import { mapVFOptions, settingMixin } from "@/CommonDP/VForm/utils";
import metadataService from "@/CommonDP/service/metadata-service.js";
export default {
  mixins: [settingMixin],
  inject: ["getGlobalDsv"],
  data() {
    return {
      subformList: [],
      nameRequiredRule: [{ required: true, message: "关联子表不可为空" }]
    };
  },
  computed: {
    ...mapVFOptions("sublist", "gridMaxHeight", "fixedNum"),
    formId() {
      return this.getGlobalDsv()?.formId;
    }
  },
  mounted() {
    this.getInit();
  },
  methods: {
    async getInit() {
      this.subformList = [];
      const res = await metadataService.querySubformList(this.formId);
      if (!this.sublist && res.data.length > 0) {
        this.sublist = res.data[0].slaveTableName;
      }
      this.subformList =
        res.data.map((e) => {
          return {
            label: e.slaveTableBusinessName || e.slaveTableName,
            name: e.slaveTableName
          };
        }) || [];
    }
  }
};
</script>
